<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1
          v-if="account && ((account.singleFunderAccount && account.beneficiaryServiceRef) || !account.singleFunderAccount)"
          class="page-title font-custom text-uppercase mt-3"
        >
          {{ $t('label.account.detail.beneficiaryAccountDetails') }}
        </h1>
        <h1
          v-else
          class="page-title font-custom text-uppercase mt-3"
        >
          {{ $t('label.account.detail.funderAccountDetails') }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>

        <div v-if="$store.state.accounts.accountDetail">
          <div
            id="accordionDetail"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingOne"
              data-bs-toggle="collapse"
              href="#collapseDetail"
              aria-expanded="false"
              aria-controls="collapseDetail"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.details') }}
            </div>
            <div
              id="collapseDetail"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionDetail"
              class="card-body collapse "
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.detail.accountStatus') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.accountStatus) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.beneficiary') }}
                </div>
                <div class="col">
                  <template v-if="$store.state.accounts.accountDetail.beneficiaryServiceContext">
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showBeneficiary($store.state.accounts.accountDetail.beneficiaryServiceContext)"
                    >
                      {{ $filters.nullFilter($store.state.accounts.accountDetail.beneficiaryServiceRef) }}
                    </div>
                  </template>
                  <template v-else>
                    {{ $filters.nullFilter($store.state.accounts.accountDetail.beneficiaryServiceRef) }}
                  </template>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.selectedCreationDate') }}
                </div>
                <div class="col">
                  {{ $filters.dateYYYYMMDD($store.state.accounts.accountDetail.creationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.card.distributor') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.distributorRef) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.selectedFunderContract') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.funderContractRef) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionCompte"
            class="card rounded-0 mb-4"
          >
            <div
              v-if="(account.singleFunderAccount && account.beneficiaryServiceRef) || !account.singleFunderAccount"
              id="heading2"
              data-bs-toggle="collapse"
              href="#collapseCompte"
              aria-expanded="false"
              aria-controls="collapseCompte"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.account') }}
            </div>
            <div
              v-else
              id="heading2"
              data-bs-toggle="collapse"
              href="#collapseCompte"
              aria-expanded="false"
              aria-controls="collapseCompte"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.funderAccount') }}
            </div>
            <div
              id="collapseCompte"
              aria-labelledby="heading2"
              data-bs-parent="#accordionCompte"
              class="card-body collapse "
            >
              <div
                v-if="$store.state.accounts.accountDetail && !$store.state.accounts.accountDetail.globalProduct"
                class="d-block w-100 p-2"
              >
                <div class="row">
                  <div class="col-3 text-end">
                    {{ $t('label.account.account') }}
                  </div>
                  <div class="col">
                    <template v-if="$store.state.accounts.accountDetail.accountDetailsPageContext ">
                      <strong>
                        {{ $t('label.account.beneficiaryAccount') }}
                      </strong>
                    </template>
                    <template v-else-if="account.singleFunderAccount">
                      <strong>
                        {{ $t('label.account.funderAccount') }}
                      </strong>
                    </template>
                    <template v-else>
                      --
                    </template>
                  </div>
                </div>
                <div
                  v-if="(account.beneficiaryServiceRef && !account.singleFunderAccount) || (!account.beneficiaryServiceRef && account.singleFunderAccount)"
                  class="row"
                >
                  <div class="col-3 text-end">
                    {{ $t('label.account.balance') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.accounts.accountDetail.accountBalance) }}
                  </div>
                </div>
                <div
                  v-if="account.beneficiaryServiceRef || !account.singleFunderAccount"
                  class="row"
                >
                  <div class="col-3 text-end">
                    {{ $t('label.account.openToBuy') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.accounts.accountDetail.accountAvailable) }}
                  </div>
                </div>
              </div>
              <div
                v-if="$store.state.accounts.accountDetail && $store.state.accounts.accountDetail.multiAccount"
                class="row"
              >
                <div
                  v-for="account in $store.state.accounts.accountDetail.accountList"
                  :key="account.category"
                  class="d-block w-100 p-2"
                >
                  <div class="row">
                    <div class="col-3 text-end">
                      {{ $t('label.account.category') }}
                    </div>
                    <div class="col">
                      <strong>
                        {{ $filters.nullFilter(account.accountCategory) }}
                      </strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 text-end">
                      {{ $t('label.account.accountNumber') }}
                    </div>
                    <div
                      role="button"
                      class="clickable-div col"
                      @click="showAccountMulti({
                        accountNumber: account.accountNumber,
                        issuerId: $store.state.accounts.account.issuerId,
                        beneficiaryServiceRef: $store.state.accounts.account.beneficiaryServiceRef
                      })"
                    >
                      {{ $filters.nullFilter(account.accountNumber) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 text-end">
                      {{ $t('label.account.balance') }}
                    </div>
                    <div class="col">
                      {{ $filters.nullFilter(account.availableBalance) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 text-end">
                      {{ $t('label.account.openToBuy') }}
                    </div>
                    <div class="col">
                      {{ $filters.nullFilter(account.openToBuy) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$store.state.accounts.accountDetail.cardAndOrderListIsNotNull">
            <div
              v-if="$store.state.accounts.accountDetail.cards"
              id="accordionCarte"
              class="card rounded-0 mb-4"
            >
              <div
                id="heading3"
                data-bs-toggle="collapse"
                href="#collapseCarte"
                aria-expanded="false"
                aria-controls="collapseCarte"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.account.cards') }}
              </div>
              <div
                id="collapseCarte"
                aria-labelledby="heading3"
                data-bs-parent="#accordionCarte"
                class="card-body collapse "
              >
                <div v-if="$store.state.accounts.accountDetail.cards">
                  <div
                    v-for="opcCard in $store.state.accounts.accountDetail.cards"
                    :key="opcCard.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardId') }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showCard(opcCard)"
                          >
                            {{ opcCard.cardId }}
                          </div>
                        </strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardStatus') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(opcCard.cardStatus) }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.panCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.panCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.psnCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.psnCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.expiryDate') }}
                      </div>
                      <div class="col">
                        {{ opcCard.expiryDate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="$store.state.accounts.accountDetail.orders"
              id="accordionCommande"
              class="card rounded-0 mb-4"
            >
              <div
                id="heading4"
                data-bs-toggle="collapse"
                href="#collapseCommande"
                aria-expanded="false"
                aria-controls="collapseCommande"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.account.orders') }}
              </div>
              <div
                id="collapseCommande"
                aria-labelledby="heading4"
                data-bs-parent="#accordionCommande"
                class="card-body collapse "
              >
                <div v-if="$store.state.accounts.accountDetail.orders">
                  <div
                    v-for="opcOrder in $store.state.accounts.accountDetail.orders"
                    :key="opcOrder.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ opcOrder.orderType }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showOrder(opcOrder)"
                          >
                            n° {{ opcOrder.orderId }}
                          </div>
                        </strong>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.expeditionRef') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.expeditionRef }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.orderStatus') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.orderStatus }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionOperation"
            class="card rounded-0 mb-4"
          >
            <div
              id="heading5"
              data-bs-toggle="collapse"
              href="#collapseOperation"
              aria-expanded="false"
              aria-controls="collapseOperation"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.operations') }}
            </div>
            <div
              id="collapseOperation"
              aria-labelledby="heading5"
              data-bs-parent="#accordionOperation"
              class="card-body collapse "
            >
              <template v-if="$store.state.accounts.accountDetail.voucherList">
                <table class="table table-hover table-sm table-striped border">
                  <thead>
                    <tr>
                      <th>{{ $t('label.account.detail.rightReference') }}</th>
                      <th>{{ $t('label.account.detail.startDate') }}</th>
                      <th>{{ $t('label.account.detail.expirationDate') }}</th>
                      <th>{{ $t('label.account.detail.statusReasonCode') }}</th>
                      <th>{{ $t('label.account.detail.loadedAmountRemaining') }}</th>
                      <th>{{ $t('label.account.detail.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="voucher in $store.state.accounts.accountDetail.voucherList"
                      :key="voucher.id"
                      class="mb-3"
                    >
                      <td>{{ voucher.transactionId }}</td>
                      <td>{{ $filters.dateYYYYMMDD(voucher.startingDate) }}</td>
                      <td>{{ $filters.dateYYYYMMDD(voucher.expiryDate) }}</td>
                      <td> {{ getReasonsForStatus(voucher) }}</td>
                      <td> {{ voucher.amounts }}</td>
                      <td>
                        <button
                          v-if="voucher.operations"
                          type="button"
                          class="btn btn-sm btn-outline-primary rounded-pill font-accent"
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title="Voir les opérations de ce voucher"
                          @click="updateOperations (voucher.operations)"
                        >
                          <i
                            class="fa fa-tasks"
                            aria-hidden="true"
                          />
                        </button>
                        <button
                          v-else
                          type="button"
                          class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom"
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title="Aucune opération pour ce voucher"
                          disabled
                        >
                          <i
                            class="fa fa-tasks"
                            aria-hidden="true"
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  v-if="operations"
                  class="well card-header"
                >
                  <button
                    type="button"
                    class="btn-close float-end"
                    aria-label="Close"
                    @click="updateOperations (null)"
                  />
                  <h4>{{ $t('label.account.operation.voucherOperations') }}</h4>
                  <table class="table table-hover table-sm table-striped border">
                    <thead>
                      <tr>
                        <th>{{ $t('label.account.operation.operationId') }}</th>
                        <th>{{ $t('label.account.operation.operationType') }}</th>
                        <th>{{ $t('label.account.operation.extReference') }}</th>
                        <th>{{ $t('label.account.operation.operationDate') }}</th>
                        <th>{{ $t('label.account.detail.actions') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="operation in operations"
                        :key="operation.id"
                        class="mb-3"
                      >
                        <td>{{ operation.operationId }}</td>
                        <td>{{ operation.operationType }}</td>
                        <td>{{ operation.externalReference }}</td>
                        <td>{{ $filters.dateYYYYMMDD(operation.operationDate) }}</td>
                        <td>
                          <button
                            type="button"
                            class="rounded-pill font-custom"
                          >
                            <div
                              role="button"
                              class="btn btn-default"
                              href="#"
                              @click="showOperation(operation)"
                            >
                              {{ $t('label.account.operation.consult') }}
                            </div>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-else>
                {{ $t('label.account.noElement') }}
              </template>
            </div>
          </div>

          <div
            id="accordionRestriction"
            class="card rounded-0 mb-4"
          >
            <div
              id="heading6"
              data-bs-toggle="collapse"
              href="#collapseRestriction"
              aria-expanded="false"
              aria-controls="collapseRestriction"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.restriction.restrictions') }}
            </div>
            <div
              id="collapseRestriction"
              aria-labelledby="heading6"
              data-bs-parent="#accordionRestriction"
              class="card-body collapse "
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.minAmountLoad') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.minLoadAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.maxAmountLoad') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.maxLoadAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.minAmountUnload') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.minUnLoadAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.maxAmountUnload') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.maxUnLoadAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.minPurchaseLimit') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.minPurchaseAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.maxPurchaseLimit') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.maxPurchaseAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.fixedProhibitedPeriods') }}
                </div>
                <div class="col">
                  <ul
                    v-if="$store.state.accounts.accountDetail.forbiddenDatePeriodList"
                    class="list-unstyled"
                  >
                    <li
                      v-for="period in $store.state.accounts.accountDetail.forbiddenDatePeriodList"
                      :key="period.id"
                    >
                      {{ period }}
                    </li>
                  </ul>
                  <div v-else>
                    --
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.authorizedUtilizationDays') }}
                </div>
                <div class="col">
                  <ul
                    v-if="$store.state.accounts.accountDetail.usageDaysPerWeekList"
                    class="list-unstyled"
                  >
                    <li
                      v-for="day in $store.state.accounts.accountDetail.usageDaysPerWeekList"
                      :key="day.id"
                    >
                      {{ day }}
                    </li>
                  </ul>
                  <div v-else>
                    --
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.MCCRestrictions') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.accounts.accountDetail.ihmMCCLimit) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.authorizedUtilizationHours') }}
                </div>
                <div class="col">
                  <ul
                    v-if="$store.state.accounts.accountDetail.usageTimePeriods"
                    class="list-unstyled"
                  >
                    <li
                      v-for="period in $store.state.accounts.accountDetail.usageTimePeriods"
                      :key="period.id"
                    >
                      {{ period }}
                    </li>
                  </ul>
                  <div v-else>
                    --
                  </div>
                </div>
              </div>
              <div
                v-if="$store.state.accounts.accountDetail.ihmFixedLimitPositionList"
                class="row"
              >
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.paymentsRestrictionsFixedPeriod') }}
                </div>
                <div class="col">
                  <table class="table table-hover table-sm table-striped border">
                    <thead>
                      <tr>
                        <th>{{ $t('label.account.restriction.periodType') }}</th>
                        <th>{{ $t('label.account.restriction.maxAmountUnloadPeriod') }}</th>
                        <th>{{ $t('label.account.restriction.maxNumberPeriod') }}</th>
                        <th>{{ $t('label.account.restriction.transactionType') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="ihmFixedLimitPosition in $store.state.accounts.accountDetail.ihmFixedLimitPositionList"
                        :key="ihmFixedLimitPosition.id"
                        class="mb-3"
                      >
                        <td>{{ $filters.nullFilter(ihmFixedLimitPosition.fixedExternalReference) }}</td>
                        <td>{{ $filters.nullFilter(ihmFixedLimitPosition.fixedUpperLimit) }}</td>
                        <td>{{ $filters.nullFilter(ihmFixedLimitPosition.fixedMaxNumber) }}</td>
                        <td> {{ $filters.nullFilter(ihmFixedLimitPosition.transactionType) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                v-if="$store.state.accounts.accountDetail.ihmSliddingLimitPositionList"
                class="row"
              >
                <div class="col-3 text-end">
                  {{ $t('label.account.restriction.paymentsRestrictionsSlidingPeriod') }}
                </div>
                <div class="col">
                  <table class="table table-hover table-sm table-striped border">
                    <thead>
                      <tr>
                        <th>{{ $t('label.account.restriction.periodType') }}</th>
                        <th>{{ $t('label.account.restriction.maxAmountUnloadPeriod') }}</th>
                        <th>{{ $t('label.account.restriction.maxNumberPeriod') }}</th>
                        <th>{{ $t('label.account.restriction.transactionType') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="ihmSliddingLimitPosition in $store.state.accounts.accountDetail.ihmSliddingLimitPositionList"
                        :key="ihmSliddingLimitPosition.id"
                        class="mb-3"
                      >
                        <td>{{ $filters.nullFilter(ihmSliddingLimitPosition.fixedExternalReference) }}</td>
                        <td>{{ $filters.nullFilter(ihmSliddingLimitPosition.fixedUpperLimit) }}</td>
                        <td>{{ $filters.nullFilter(ihmSliddingLimitPosition.fixedMaxNumber) }}</td>
                        <td> {{ $filters.nullFilter(ihmSliddingLimitPosition.transactionType) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <goTopButton />
  </div>
</template>

<script src="./AccountDetail.js"></script>

<style src="./AccountDetail.scss" scoped lang="scss"></style>
